import { isUnitB, isUnitC } from '@shared/helpers/unit.helpers';
import { getStripedBackground } from './get-striped-background';

const LIFECYCLE_BAR_STRIPE_BANDS = {
  gap: { color: 'transparent', width: 2 },
  stripe: { color: 'rgba(255,255,255,0.45)', width: 3 },
} as const;

/** Lifecycle bar hatch angle (diagonal), shared by B- and C-phase segments. */
export const LIFECYCLE_BAR_STRIPE_ANGLE = -45;

export type LifecycleBarStripePhase = 'B' | 'C';

/**
 * CSS `background-image` for a lifecycle bar stripe overlay.
 * B- and C-phase segments use the same hatch pattern.
 */
export const getLifecycleBarStripeBackground = (
  _phase: LifecycleBarStripePhase,
): string =>
  getStripedBackground({
    angle: LIFECYCLE_BAR_STRIPE_ANGLE,
    ...LIFECYCLE_BAR_STRIPE_BANDS,
  });

/**
 * Resolve B/C stripe phase for a CO₂ chart segment key, if any.
 */
export const getLifecycleBarStripePhase = (
  key: string | undefined,
): LifecycleBarStripePhase | undefined => {
  if (!key) return undefined;
  if (isUnitB(key)) return 'B';
  if (isUnitC(key)) return 'C';
  return undefined;
};
